import LlamadaService from './llamada_service.js';
import ConfigService from './config_service.js';
import LoginService from './login_service.js';

const llamada = new LlamadaService();
const configService = new ConfigService();
const config = configService.getConfig();
const loginService = new LoginService();
export default class InternacionService {
	get(data) {
		data.action = 'get';
		const token = loginService.getToken();
		return llamada.sendPost(config.baseUrl + 'InternacionWebService.php?token='+token, data);
	}

	save(data) {
		data.action = 'save';
		const token = loginService.getToken();
		return llamada.sendPost(config.baseUrl + 'InternacionWebService.php?token='+token, data);
	}

	activate(data) {
		data.action = 'activate';
		const token = loginService.getToken();
		return llamada.sendPost(config.baseUrl + 'InternacionWebService.php?token='+token, data);
	}

	deactivate(data) {
		data.action = 'deactivate';
		const token = loginService.getToken();
		return llamada.sendPost(config.baseUrl + 'InternacionWebService.php?token='+token, data);
	}

	remove(data) {
		data.action = 'remove';
		const token = loginService.getToken();
		return llamada.sendPost(config.baseUrl + 'InternacionWebService.php?token='+token, data);
	}

	formatInternacion(internacion) {
		internacion.ambulatorioInternacion = internacion.ambulatorioInternacion == 0 ? "NO" : internacion.ambulatorioInternacion == 1 ? "SI" : internacion.ambulatorioInternacion;
		return 'CAMA:' + internacion.camaInternacion + ' - AMBULATORIO: ' + internacion.ambulatorioInternacion + ' - DIAGNOSTICO: ' + internacion.diagnosticoInternacion + ' - ESPECIALIDAD: ' + internacion.especialidadInternacion.descripcionDatoParametrico + ' - STAFF: ' + internacion.nombreStaffInternacion;
	}
}

